module.exports = __webpack_public_path__ + "static/img/contect_3.5f4b85f4.jpg";